<ax-value-view type="RICH_TEXT" [value]="value$ | async" (click)="clicked($event)"></ax-value-view>
